<template>
  <ContentLayout
    widthClass="max-1000"
    pad="0"
    :title="
      iSEdited
        ? $t('label_essweb_BlockLeavePolicy_form_editTitle')
        : $t('label_essweb_BlockLeavePolicy_form_viewTitle')
    "
    @cancel="toBack"
    :delBtn="hasBtn('delete-admin-block-leave-policy-group')"
    :initData="BlockLeaveGroupData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'block_leave_group_name',
      'block_leave_group_code',
      'include_holiday',
      'start_month',
      'min_days',
      'include_day_off',
      'remarks',
    ]"
    :editBtn="!iSEdited && hasBtn('edit-admin-block-leave-policy-group')"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_BlockLeavePolicy_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row align="center" justify="start" class="white lighten-5">
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  maxlength="100"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="BlockLeaveGroupData.block_leave_group_name"
                  @change="
                    (valueArr) => {
                      BlockLeaveGroupData.block_leave_group_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_BlockLeavePolicy_list_BlockLeaveGroupNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :label="
                    $t(
                      'label_essweb_BlockLeavePolicy_form_BlockLeaveGroupCodeLabel'
                    )
                  "
                  maxlength="100"
                  v-model="BlockLeaveGroupData.block_leave_group_code"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <numberInputTextFiled
                  disabled
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 99])
                  "
                  v-model="BlockLeaveGroupData.start_month"
                  :label="
                    $t(
                      'label_essweb_BlockLeavePolicy_form_BlockLeaveStartMonthLabel'
                    )
                  "
                  :max="12"
                  :min="1"
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <numberInputTextFiled
                  disabled
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 99])
                  "
                  v-model="BlockLeaveGroupData.min_days"
                  :label="
                    $t(
                      'label_essweb_BlockLeavePolicy_form_BlockLeaveMinDaysLabel'
                    )
                  "
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <BooleanRadioField
                  :disabled="!iSEdited"
                  v-model="BlockLeaveGroupData.include_holiday"
                  isRequire
                  :label="
                    $t('label_essweb_BlockLeavePolicy_form_includeHolidayLabel')
                  "
                  @click="
                    (boolean) => {
                      BlockLeaveGroupData.include_holiday = boolean;
                    }
                  "
              /></v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <BooleanRadioField
                  :disabled="!iSEdited"
                  v-model="BlockLeaveGroupData.include_day_off"
                  isRequire
                  :label="
                    $t('label_essweb_BlockLeavePolicy_form_includeDayOffLabel')
                  "
                  @click="
                    (boolean) => {
                      BlockLeaveGroupData.include_day_off = boolean;
                    }
                  "
              /></v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-btn
            text
            small
            class="text-capitalize"
            color="primary"
            v-if="iSEdited"
            @click="newLeveType()"
          >
            {{ $t("label_essweb_leaveType_list_title") }}
            <span class="material-icons-round">add</span>
          </v-btn>
          <noContent v-if="LeaveType.length <= 0" />
          <v-container fluid class="ma-0 pa-0 px-3">
            <v-form ref="form2" lazy-validation>
              <v-sheet
                class="d-flex align-center my-3"
                v-for="(item, index) in LeaveType"
                :key="`leavetype--${index}`"
              >
                <AutoComplete
                  class="flex-grow-1"
                  isRequired
                  two-line
                  :filled="true"
                  :readonly="true"
                  :items="LeaveTypeList"
                  item-text="leave_type_name"
                  label="label_essweb_leaveType_list_title"
                  item-value="uuid"
                  :rules="$GetRules(['_Require_ArrRules'], [null])"
                  v-model="item.uuid"
                >
                  <template v-slot:selection="{ data }">
                    {{ $getCommonLangValue(data.item.leave_type_name) }}
                    <span class="text--secondary text-caption"
                      >({{
                        $getCommonLangValue(data.item.leave_type_abbr)
                      }})</span
                    >
                  </template>
                  <template v-slot:item.title="{ data }">
                    {{ $getCommonLangValue(data.item.leave_type_name) }}
                  </template>
                  <template v-slot:item.subtitle="{ data }">
                    {{ $getCommonLangValue(data.item.leave_type_abbr) }}
                  </template>
                </AutoComplete>
                <v-btn
                  icon
                  class="text-capitalize ml-1"
                  v-if="iSEdited"
                  color="secondary"
                  @click="deleteLeveType(item)"
                >
                  <span class="material-icons-round">delete</span>
                </v-btn>
              </v-sheet>
            </v-form>
          </v-container>
        </template>
      </Taber>

      <!-- content -->
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <newMapping ref="newMapping" @change="getMappingList" />
    </template>
    <!-- tools end -->
  </ContentLayout>
</template>
<script>
import dayjs from "dayjs";
import newMapping from "@/Page/EssAdmin/BlockLeave/BlockLeavePolicy/components/newMapping";
import { mapGetters } from "vuex";
export default {
  name: "newevent",
  components: { newMapping },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  watch: {},
  data() {
    return {
      curTab: "tab-1",
      isChanged: false,
      taber: [
        "label_essweb_BlockLeavePolicy_form_step_generalLabel",
        "label_essweb_BlockLeavePolicy_form_step_LeaveTypeMappingLabel",
      ],
      LeaveTypeList: [],
      LeaveType: [],
      iSEdited: false,
      BlockLeaveGroupData: {
        block_leave_group_name: "",
        block_leave_group_code: "",
        include_holiday: 0,
        include_day_off: 0,
        start_month: 1,
        min_days: 0,
        remarks: "",
      },
    };
  },
  created() {
    this.getLeaveType();
  },
  mounted() {
    this.getBtnPermissionList();
    this.getDetail();
    this.getMappingList();
  },
  methods: {
    getLeaveType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-list/",
      }).then((res) => {
        that.LeaveTypeList = res.data;
      });
    },
    getMappingList() {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_group",
        url: "/block-leave-group-map/get-list/",
        data: { block_leave_group_uuid: this.$route.params.params },
      }).then((res) => {
        that.LeaveType = res.data.map((item) => {
          return Object.assign(item, { key: item.uuid });
        });
      });
    },
    getDetail() {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_group",
        url: "/block-leave-group/get-details/",
        data: { uuid: this.$route.params.params },
      }).then((res) => {
        res.data["block_leave_group_name_save"] =
          res.data.block_leave_group_name;
        res.data.block_leave_group_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.block_leave_group_name
        );
        this.BlockLeaveGroupData = Object.assign(
          this.BlockLeaveGroupData,
          res.data
        );
      });
    },
    toBack: function () {
      // if (this.iSEdited) {
      //   this.showSelect = false;
      //   this.iSEdited = false;
      // } else {
      this.$router.back();
      // }
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_group",
        url: "/block-leave-group/delete/",
        data: { uuids: this.$route.params.params },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_BlockLeavePolicy_list_deleteBlockLeavePolicySuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    newLeveType() {
      this.$refs.newMapping.new(this.$route.params.params);
    },
    deleteLeveType(obj) {
      //   this.LeaveType = this.LeaveType.filter((ele) => ele.key !== key);
      this.$confirmWarn(
        this.$t("message_tips"),
        this.$t(
          "message_essweb_BlockLeavePolicy_form_deleteBlockLeavePolicyMappingLabel"
        )
      ).then((res) => {
        if (res) {
          this.$Request({
            method: "POST",
            table: "ess_lv_block_leave_group_map_leave_type",
            url: "/block-leave-group-map/delete/",
            data: {
              block_leave_group_uuid: this.$route.params.params,
              leave_type_uuid: obj.uuid,
            },
          }).then((res) => {
            this.getMappingList();
          });
        }
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate() || !this.$refs["form2"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_group",
        url: "/block-leave-group/update/",
        data: {
          uuid: this.$route.params.params,
          block_leave_group_code:
            this.BlockLeaveGroupData.block_leave_group_code,
          block_leave_group_name: this.$transCommonLangKey(
            this.BlockLeaveGroupData.block_leave_group_name,
            this.BlockLeaveGroupData.block_leave_group_name_save
          ),
          include_holiday: Number(this.BlockLeaveGroupData.include_holiday)
            ? 1
            : 0,
          include_day_off: Number(this.BlockLeaveGroupData.include_day_off)
            ? 1
            : 0,
          start_month: this.BlockLeaveGroupData.start_month,
          min_days: this.BlockLeaveGroupData.min_days,
          remarks: this.BlockLeaveGroupData.remarks,
          //   ess_lv_block_leave_group_map_leave_type: this.LeaveType.map(
          //     (item) => {
          //       return {
          //         leave_type_uuid: item.uuid,
          //       };
          //     }
          //   ),
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_eventPropertyGroup_list_updateEventPropertyGroupSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>
